<script setup lang="ts">
import { FOOTER_NAV_ITEMS } from "@/config/nav";
import { useRouter } from "vue-router";

// 导入图片资源
import fLogo from "@/assets/images/f-logo.svg";
import icoFrame from "@/assets/images/ico-frame.svg";
import icoRednote from "@/assets/images/ico-rednote.svg";
import icoTiktok from "@/assets/images/ico-tiktok.svg";
import qrDy from "@/assets/images/qr-dy.png";
import qrRdnt from "@/assets/images/qr-rednote.png";
import qrWx from "@/assets/images/qr-wx.png";

const router = useRouter();

// 导航链接数据（从配置文件导入）
const navLinks = FOOTER_NAV_ITEMS;

// 处理导航点击
const handleNavClick = (path: string) => {
  // 判断是否为外部链接
  if (path.startsWith("http://") || path.startsWith("https://")) {
    window.open(path, "_blank");
  } else {
    router.push(path);
  }
};
</script>

<template>
  <footer class="bg-[#121a44] pt-[50px] sm:pt-[80px]">
    <div class="page-container">
      <div class="sm:flex justify-between flex-wrap">
        <!-- 左侧Logo区域 -->
        <div class="lg:w-[250px] sm:w-[200px] w-[100px]" @click="handleNavClick('/')">
          <!-- 四花瓣白色图标 -->
          <img class="w-full h-full object-cover" :src="fLogo" alt="四花瓣白色图标" />
        </div>

        <!-- 中间导航区域 -->
        <div
          class="w-full mt-[40px] sm:mt-0 sm:w-[500px] flex justify-start items-center flex-wrap"
        >
          <ul class="w-full sm:flex flex-wrap">
            <li
              class="mb-[24px] w-full pb-[15px] sm:w-[33.33%] text-white border-b-[1px] border-white/20 sm:border-none"
              v-for="link in navLinks"
              :key="link.path"
            >
              <div
                class="hover:text-[#94a3b8] text-[16px] cursor-pointer"
                @click="handleNavClick(link.path)"
              >
                {{ link.label }}{{ link.isUnderConstruction ? "（建设中）" : "" }}
              </div>
            </li>
          </ul>
        </div>

        <!-- 右侧联系区域 -->
        <div class="sm:w-full xl:w-[300px] text-right">
          <div class="text-[16px] text-white">商务合作</div>
          <div class="sm:mt-[24px] text-[16px] text-white">
            联系邮箱：china_ugd@163.com
          </div>
          <div class="mt-[24px] flex justify-end items-center gap-4">
            <div class="relative z-[1] group">
              <div
                class="w-[40px] h-[40px] bg-[#fff] rounded-[50%] flex items-center justify-center"
              >
                <img
                  class="w-[24px] h-[24px] object-cover"
                  :src="icoFrame"
                  alt="公众号"
                />
              </div>
              <div
                class="absolute bottom-[60px] right-0 4xl:right-[50%] 4xl:translate-x-[50%] w-[120px] h-[120px] p-[10px] bg-white rounded-[10px] after:content-[''] after:absolute after:z-[1] after:top-full after:right-[12px] 4xl:after:left-[50%] 4xl:after:-translate-x-[50%] after:w-0 after:h-0 after:border-l-[8px] after:border-r-[8px] after:border-t-[9px] after:border-l-transparent after:border-r-transparent after:border-t-white opacity-0 transition-opacity duration-300 invisible group-hover:visible group-hover:opacity-100"
              >
                <img class="w-full h-full object-cover" :src="qrWx" alt="" />
              </div>
            </div>
            <div class="relative z-[1] group">
              <div
                class="w-[40px] h-[40px] bg-[#fff] rounded-[50%] flex items-center justify-center"
              >
                <img
                  class="w-[24px] h-[24px] object-cover"
                  :src="icoRednote"
                  alt="微信"
                />
              </div>
              <div
                class="absolute bottom-[60px] right-0 4xl:right-[50%] 4xl:translate-x-[50%] w-[120px] h-[120px] p-[10px] bg-white rounded-[10px] after:content-[''] after:absolute after:z-[1] after:top-full after:right-[12px] 4xl:after:left-[50%] 4xl:after:-translate-x-[50%] after:w-0 after:h-0 after:border-l-[8px] after:border-r-[8px] after:border-t-[9px] after:border-l-transparent after:border-r-transparent after:border-t-white opacity-0 transition-opacity duration-300 invisible group-hover:visible group-hover:opacity-100"
              >
                <img class="w-full h-full object-cover" :src="qrRdnt" alt="" />
              </div>
            </div>
            <div class="relative z-[1] group">
              <div
                class="w-[40px] h-[40px] bg-[#fff] rounded-[50%] flex items-center justify-center"
              >
                <img class="w-[24px] h-[24px] object-cover" :src="icoTiktok" alt="微博" />
              </div>
              <div
                class="absolute bottom-[60px] right-0 4xl:right-[50%] 4xl:translate-x-[50%] w-[120px] h-[120px] p-[10px] bg-white rounded-[10px] after:content-[''] after:absolute after:z-[1] after:top-full after:right-[12px] 4xl:after:left-[50%] 4xl:after:-translate-x-[50%] after:w-0 after:h-0 after:border-l-[8px] after:border-r-[8px] after:border-t-[9px] after:border-l-transparent after:border-r-transparent after:border-t-white opacity-0 transition-opacity duration-300 invisible group-hover:visible group-hover:opacity-100"
              >
                <img class="w-full h-full object-cover" :src="qrDy" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部版权信息 -->
      <div class="copyright py-[30px] sm:py-[50px] text-center text-[12px] text-white">
        Copyright © 2006-2025 UGD 全国联合毕业设计 湘ICP备10078294号-4 湘ICP证13001364号
      </div>
    </div>
  </footer>
</template>

<style scoped></style>
